module.exports = __webpack_public_path__ + "img/Weapon_125.ef1e96e7.png";